export default function getScrollbarVisible(element) {
	return element.scrollWidth > element.clientWidth;
};
